import { __rest } from "tslib";
import React from "react";
import { colors } from "../../shared/constants";
import * as S from "./styles";
export var InformationV2 = function InformationV2(e) {
  var _e$color = e.color,
      t = _e$color === void 0 ? colors.teal6 : _e$color,
      o = __rest(e, ["color"]);

  return React.createElement(S.BaseSVG, Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1Z",
    stroke: t,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.255 10.525H13.055V17.725H11.255V10.525ZM11 8.08C11 7.79 11.1075 7.5375 11.3225 7.3225C11.5375 7.1075 11.81 7 12.14 7C12.47 7 12.7475 7.1025 12.9725 7.3075C13.1975 7.5125 13.31 7.77 13.31 8.08C13.31 8.39 13.1975 8.6475 12.9725 8.8525C12.7475 9.0575 12.47 9.16 12.14 9.16C11.81 9.16 11.5375 9.0525 11.3225 8.8375C11.1075 8.6225 11 8.37 11 8.08Z",
    fill: t
  }));
};